import { Injectable } from '@angular/core';
import { ApiService } from '../..';

@Injectable()
export class DocTucThoiDiemDoService {
  public listDienLuc: any = Array();
  public listData: any = [];
  APIURL = "api/SendByteTCP/DTT";
  constructor(public api: ApiService) { }

  public layThongTin1Pha(listMeterID, isTram, kieuDoc) {
    var param = {
      "config": '{"namesql":"PKG_DOCTUCTHOI.P_LAY_TT_KH_DOCTUCTHOI"}',
      "para": '{"v_danhsachid":"' + listMeterID + '","v_tram":"' + isTram + '","v_kieudoc":"' + kieuDoc + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  layKetQua(listMeterID, thoiDiem, kieuDoc, loaipha, isTram) {
    var param = {
      "config": '{"namesql":"PKG_DOCTUCTHOI.P_LAY_KETQUA"}',
      "para": '{"v_danhsachid":"' + listMeterID + '","v_thoidiem":"' + thoiDiem + '","v_kieudoc":"' + kieuDoc + '","v_loaipha":"' + loaipha + '","v_tram":"' + isTram + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  layThongTin3Pha(listMeterID, isTram, kieuDoc) {
    var param = {
      "config": '{"namesql":"PKG_DOCTUCTHOI.P_DOCTUCTHOI_3PHA"}',
      "para": '{"v_danhsachid":"' + listMeterID + '","v_tram":"' + isTram + '","v_kieudoc":"' + kieuDoc + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/giam-sat/doc-tuc-thoi-diem-do/doctucthoidiemdo.service.ts